import { useFormikContext } from 'formik';

import { ProductGroup } from '../../../../types/ProductGroup';
import { FormikEnumOptionSelect } from '../../../common/form-elements/formik/FormikEnumOptionSelect';
import { translate } from '../../../common/helpers/translate.helper';
import { PackType } from '../../../common/models/ItemModel';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import type { PriceCompareItem } from '../types/PriceCompareItem';
import { updatePriceCompareItemPackType } from '../utils/updatePriceCompareItemPackType';

interface FormikPriceComparePackTypeSelectProps {
    name: string;
    item: PriceCompareItem;
}

export const FormikPriceComparePackTypeSelect = ({ name, item }: FormikPriceComparePackTypeSelectProps) => {
    const { setFieldValue } = useFormikContext<PriceCompareFormValues>();
    const specialProduct = item.group === ProductGroup.SAMPLE_ANALYSIS || item.group === ProductGroup.TEST_KIT;

    return (
        <FormikEnumOptionSelect
            name={`${name}.packType`}
            enumType="packType"
            placeholder={translate('compare.placeholder.packType')}
            filter={(option) => {
                if (!item.group) {
                    return true;
                }
                const specialPackType = option.value === PackType.BOTTLE || option.value === PackType.PACK;
                return specialProduct ? specialPackType : !specialPackType;
            }}
            onOptionChange={(packType) => setFieldValue(name, updatePriceCompareItemPackType(item, packType))}
        />
    );
};
